<template>
  <div class="statistical-details">
    <el-dialog @open="dialogOpen" @close="dialogClose" title="统计详情" :visible.sync="dialogVisible"
      width="800px">
      <div class="statistical-list">
        <div class="statistical-item" v-for="(item, index) in statisticalDetails" :key="index">
          <div class="statistical-item-title">{{ index + 1 }}.{{ item.questionDesc }}</div>
          <div class="option-list">
            <div class="option-item" v-for="(optionItem, optionIndex) in item.optionList" :key="optionIndex">
              <div class="option-text">{{ optionItem.optionDesc }}</div>
              <el-progress :percentage="optionItem.percentageOfOptions || 0" :color="customColor"></el-progress>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['statisticalDetailsShow', 'statisticalDetails'],
  data() {
    return {
      percentage: 20,
      customColor: '#0066cc',
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.statisticalDetailsShow;
      },
      set(val) {
        this.$emit('update:statisticalDetailsShow', val);
      }
    }
  },
  methods: {
    dialogClose() {
      this.$emit("update:statisticalDetailsShow", false);
    },
    dialogOpen() {}
  }
};
</script>

<style lang="scss" scoped>
@import "./statisticalDetails.scss";
</style>